import { Sparkles, Users } from "lucide-react";
import { SOURCE } from "../data/demoContent";

export const SourcePill = ({ source, className = "", testId }) => {
  const ai = source === "ai";
  return (
    <span data-testid={testId} className={`spc-pill ${ai ? "spc-pill--ai" : ""} ${className}`}>
      {ai ? <Sparkles size={12} aria-hidden /> : <Users size={12} aria-hidden />}
      {SOURCE[source]}
    </span>
  );
};
